import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { Loader2 } from 'lucide-react';
import { AccessDenied } from '@/pages/admin/AccessDenied';

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // Check if user is super admin
  const isSuperAdmin = !!(user as any)?.is_super_admin;

  if (!isSuperAdmin) {
    // Show access denied page instead of silently redirecting
    return <AccessDenied />;
  }

  return <>{children}</>;
}

